export const def_listLimit: number = 40
/*
 * "The whole list, no paging" — and yes, that is ZERO, not a large number.
 *
 * The server reads it as `Number(args.limit) || total` (pfinder cmdList), so a falsy limit IS the
 * whole set. Written as a named constant because `limit: 0` reads like "nothing" at the call site
 * and invites being repaired into something broken.
 *
 * ⚑ Do NOT use -1 as an infinity: it is truthy, reaches `slice(cursor, cursor + limit)` and cuts the
 * last entry off. And do not use this for a SEARCH limit — cmdSearch reads `args.limit || 10`, where
 * zero means ten.
 */
export const def_listLimitAll: number = 0
export const def_footNote: string = '{$footnote='
// Reserved namePath prefix for local (non-DB) cart items — not fetched/rehydrated from the server.
export const def_localCartPrefix: string = 'local:'

export const enum ESpecialPage {
  sp_search_result = 'search-result',
  sp_shopping_cart = 'shopping-cart',
  sp_product_compare = 'product-compare',
  sp_catalogue_create = 'catalogue-create',
  sp_price_list_create = 'price-list-create',
  sp_favourites = 'favourites',
  sp_download_list = 'download-list',
  sp_custom = 'custom',
}

export const enum ECarts {
  ct_shopping_cart = 'shopping-cart',
  ct_product_compare = 'product-compare',
  ct_catalogue_create = 'catalogue-create',
  ct_price_list_create = 'price-list-create',
  ct_favourites = 'favourites',
  ct_download_list = 'download-list',
  ct_custom_1 = 'custom-1',
}

export enum EScreenSize {
  sc_none = 'none',
  sc_n_a = 'n/a',
  sc_xs = 'xs',
  sc_sm = 'sm',
  sc_md = 'md',
  sc_lg = 'lg',
  sc_xl = 'xl',
  sc_2xl = '2xl',
}

export const enum ENotificationType {
  nt_standard = 'standard',
  nt_warning = 'warning',
}

export const enum ElocalStorageType {
  ls_shoppingcart = 'shoppingcart',
  ls_userinfo = 'userinfo',
}

export const enum ESchemaContext {
  sch_context = 'https://schema.org',
}

export const enum ESchemaType {
  sch_type_product = 'Product',
  sch_type_aggregateRating = 'AggregateRating',
  sch_type_offer = 'Offer',
  sch_type_brand = 'Brand',
  sch_type_quantitive_value = 'QuantitativeValue',
}

export const enum ESchemaItemCondition {
  sch_condition_new = 'https://schema.org/NewCondition',
}

export const enum ESchemaItemAvailability {
  sch_availability_storeonly = 'https://schema.org/InStoreOnly',
}

export const enum EFilterType {
  ft_checkbox = 'checkbox',
  ft_radio = 'radio',
  ft_select = 'select',
  ft_slider = 'slider',
}
